/**
 * Finds the variant of a sibling (upsell/downsell) product that lines up with
 * the shopper's current selection on the main product.
 */
function getMatchingVariant(
  shopifyProduct,
  selectedVariant,
  attribute_override,
  variantSize
) {
  // Try to match full variant title first
  let matchingVariant = shopifyProduct?.variants?.find(
    (v) => v.title === selectedVariant?.title
  );

  // Then try to match first option (size) and attribute_override (cover)
  if (!matchingVariant) {
    const hasSameFirstOption = (v) =>
      v.selectedOptions[0].value ===
      (variantSize || selectedVariant?.selectedOptions?.[0]?.value);

    if (attribute_override) {
      matchingVariant = shopifyProduct?.variants?.find(
        (v) =>
          hasSameFirstOption(v) &&
          v.selectedOptions[1]?.value === attribute_override
      );
    } else {
      matchingVariant = shopifyProduct?.variants?.find((v) =>
        hasSameFirstOption(v)
      );
    }
  }

  // Fallback to first variant
  if (!matchingVariant) {
    matchingVariant = shopifyProduct?.variants?.[0];
  }

  return matchingVariant;
}

/**
 * What the shopper pays on top of (or below) the main product to switch to this
 * sibling product, at the currently selected size.
 */
export default function getPriceDifference({
  product,
  selectedVariant,
  variantSize
}) {
  const matchingVariant = getMatchingVariant(
    product?.shopifyProduct?.[0],
    selectedVariant,
    product?.attribute_override,
    variantSize
  );

  return (
    Math.floor(matchingVariant?.price.amount) -
    Math.floor(selectedVariant?.price)
  );
}
